import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

interface FetchProps {
	campaignId: string;
}

export const getCsvResultDownload = async ({
	campaignId,
}: FetchProps): Promise<AxiosResponse> => {
	return await api.post(`/campaigns/${campaignId}/export-result `);
};
